// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transaction_transactionListing_mobile__3BtBS {
  display: none;
  min-height: 70vh;
  background-color: white;
}



.transaction_inputs__0Y2HA {
  display: none;
}

.transaction_sellerListOptions__SGi8a {
  /* border: 1px solid red; */
  /* width: 25%; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #b9bbc0;
  padding-left: 20px;
  color: black;
  font-weight: 300;
  border-radius: 5px;
  margin-top: 10px;
}

.transaction_sellerListOptions__SGi8a select {
  background-color: blue;
  width: 187px;
  margin: 0 !important;
  color: white;
  font-weight: 500;
}

.transaction_sellerListOptions__SGi8a select option {
  background-color: #f8f9fc;
  color: black;
}

.transaction_selectionControl__L6yFb {
  position: relative;
}

.transaction_selectionControl__L6yFb::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
}

@media screen and (max-width: 1024px) {
  .transaction_headerContainer__OJF4Y {
  
    flex-direction: column;
    align-items: flex-start !important;
  }
}

@media screen and (max-width: 768px) {



  .transaction_transactionListing_desktop__t815J {
    display: none;
  }

  .transaction_orderDesktopSearches__HJrdv {
    display: none;
  }


  .transaction_transactionListing_mobile__3BtBS {
    display: block;
    padding: 10px;
    background-color: white;
  }

  .transaction_cardbody__zxk\\+3 {
    background-color: #F5F5F5;
    padding: 15px !important;
  }

  .transaction_inputs_desktop__\\+uqU6 {
    display: none;
  }

  .transaction_inputs__0Y2HA {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .transaction_sellerListOptions__SGi8a {
    /* width: 65%; */
    font-size: 12px;
  }

  .transaction_sellerListOptions__SGi8a select {
    width: 110px
  }

  .transaction_sellerListOptions__SGi8a~button {
    font-size: 12px !important;
  }

  .transaction_mStyle__04CxS {
    width: 90% !important;
  }


}


@media screen and (max-width: 375px) {
  .transaction_sellerListOptions__SGi8a {
    /* width: 46%; */
    font-size: 12px;
  }
}

@media screen and (max-width: 320px) {
  .transaction_sellerListOptions__SGi8a {
    width: 100%;
    font-size: 11px;
  }

  .transaction_widthControl__YAmRZ{
    width: 100%;
}


  /* .sellerListOptions select {
    width: 33px;
  } */
}`, "",{"version":3,"sources":["webpack://./src/pages/transaction/transaction.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;AACX;;AAEA;EACE;;IAEE,sBAAsB;IACtB,kCAAkC;EACpC;AACF;;AAEA;;;;EAIE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,cAAc;IACd,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE;EACF;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qBAAqB;EACvB;;;AAGF;;;AAGA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;AACf;;;EAGE;;KAEG;AACL","sourcesContent":[".transactionListing_mobile {\n  display: none;\n  min-height: 70vh;\n  background-color: white;\n}\n\n\n\n.inputs {\n  display: none;\n}\n\n.sellerListOptions {\n  /* border: 1px solid red; */\n  /* width: 25%; */\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #b9bbc0;\n  padding-left: 20px;\n  color: black;\n  font-weight: 300;\n  border-radius: 5px;\n  margin-top: 10px;\n}\n\n.sellerListOptions select {\n  background-color: blue;\n  width: 187px;\n  margin: 0 !important;\n  color: white;\n  font-weight: 500;\n}\n\n.sellerListOptions select option {\n  background-color: #f8f9fc;\n  color: black;\n}\n\n.selectionControl {\n  position: relative;\n}\n\n.selectionControl::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n\n@media screen and (max-width: 1024px) {\n  .headerContainer {\n  \n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n}\n\n@media screen and (max-width: 768px) {\n\n\n\n  .transactionListing_desktop {\n    display: none;\n  }\n\n  .orderDesktopSearches {\n    display: none;\n  }\n\n\n  .transactionListing_mobile {\n    display: block;\n    padding: 10px;\n    background-color: white;\n  }\n\n  .cardbody {\n    background-color: #F5F5F5;\n    padding: 15px !important;\n  }\n\n  .inputs_desktop {\n    display: none;\n  }\n\n  .inputs {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    margin-top: 10px;\n  }\n\n  .sellerListOptions {\n    /* width: 65%; */\n    font-size: 12px;\n  }\n\n  .sellerListOptions select {\n    width: 110px\n  }\n\n  .sellerListOptions~button {\n    font-size: 12px !important;\n  }\n\n  .mStyle {\n    width: 90% !important;\n  }\n\n\n}\n\n\n@media screen and (max-width: 375px) {\n  .sellerListOptions {\n    /* width: 46%; */\n    font-size: 12px;\n  }\n}\n\n@media screen and (max-width: 320px) {\n  .sellerListOptions {\n    width: 100%;\n    font-size: 11px;\n  }\n\n  .widthControl{\n    width: 100%;\n}\n\n\n  /* .sellerListOptions select {\n    width: 33px;\n  } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"transactionListing_mobile": `transaction_transactionListing_mobile__3BtBS`,
	"inputs": `transaction_inputs__0Y2HA`,
	"sellerListOptions": `transaction_sellerListOptions__SGi8a`,
	"selectionControl": `transaction_selectionControl__L6yFb`,
	"headerContainer": `transaction_headerContainer__OJF4Y`,
	"transactionListing_desktop": `transaction_transactionListing_desktop__t815J`,
	"orderDesktopSearches": `transaction_orderDesktopSearches__HJrdv`,
	"cardbody": `transaction_cardbody__zxk+3`,
	"inputs_desktop": `transaction_inputs_desktop__+uqU6`,
	"mStyle": `transaction_mStyle__04CxS`,
	"widthControl": `transaction_widthControl__YAmRZ`
};
export default ___CSS_LOADER_EXPORT___;
